export * from './text-page';
